import type { CustomerConfig } from './types';

// Re-export types for use in other files
export type { CustomerConfig, DailyTradingHours, TradingPeriod, ThemeConfig, SocialLinks, BookingConfig, NotificationConfig, FeatureFlags } from './types';

/**
 * Customer Configuration
 * Generated by BuunGroup IDP
 * Subdomain: booking
 */
export const customerConfig: CustomerConfig = {
  // Business Identity
  businessName: "BUUN GROUP PTY LTD",
  shortName: "BGPL",
  tagline: "Welcome to BUUN GROUP PTY LTD",
  description: "Book your table at BUUN GROUP PTY LTD",

  // Contact
  phone: "0434108676",
  email: "sacha1777@hotmail.com",

  // Address
  address: {
    street: "78 Barossa Way",
    suburb: "Spring Mountain",
    city: "Spring Mountain",
    state: "QLD",
    postalCode: "4300",
    country: "Australia",
    mapsLink: "https://maps.google.com/?q=78%20Barossa%20Way%2C%20Spring%20Mountain%2C%20Spring%20Mountain%2C%20QLD%2C%204300%2C%20Australia",
  },

  // Website & Locale
  websiteUrl: "https://buungroup.com",
  timezone: "Australia/Brisbane",
  currencyCode: 'AUD',

  // Branding
  theme: {
    primaryColor: "#6366f1",
    accentColor: "#6366f1",
    logoUrl: undefined,
    faviconUrl: '/favicon.ico',
  },

  socialLinks: {
    facebook: undefined,
    instagram: undefined,
  },

  // Booking Settings
  booking: {
    minPartySize: 1,
    maxPartySize: 10,
    slotIntervalMinutes: 30,
    defaultDurationMinutes: 90,
    maxConcurrentBookingsPerSlot: 5,
    advanceBookingDays: 30,
    minAdvanceMinutes: 60,
    maxGuestsPerSlot: 50,
    bufferMinutes: 15,
    requirePhoneNumber: true,
    requireLocationCheck: false,
    allowedCountries: ['AU'],
    enableTableSelection: false,
    editCooldownMinutes: 5,
    subsequentEditCooldownMinutes: 60,
  },

  // Notification Settings
  notifications: {
    enabled: true,
    smsEnabled: false,
    emailEnabled: true,
  },

  // Feature Flags
  features: {
    bookingEnabled: true,
    tableMapEnabled: false,
    specialOffersEnabled: false,
    locationCheckEnabled: false,
    smsNotificationsEnabled: false,
  },

  // Trading hours - default to standard restaurant hours
  // Can be customized after deployment
  tradingHours: [
    { dayIndex: 0, dayName: 'Sunday', periods: [{ open: '11:30', close: '15:00' }, { open: '17:00', close: '21:00' }], isClosed: false },
    { dayIndex: 1, dayName: 'Monday', periods: [], isClosed: true },
    { dayIndex: 2, dayName: 'Tuesday', periods: [{ open: '17:00', close: '21:30' }], isClosed: false },
    { dayIndex: 3, dayName: 'Wednesday', periods: [{ open: '17:00', close: '21:30' }], isClosed: false },
    { dayIndex: 4, dayName: 'Thursday', periods: [{ open: '17:00', close: '21:30' }], isClosed: false },
    { dayIndex: 5, dayName: 'Friday', periods: [{ open: '17:00', close: '22:00' }], isClosed: false },
    { dayIndex: 6, dayName: 'Saturday', periods: [{ open: '11:30', close: '15:00' }, { open: '17:00', close: '22:00' }], isClosed: false },
  ],
};

export default customerConfig;
